package com.macrofocus.eflux.network.crossborder

import com.macrofocus.eflux.network.logical.logicalBusIdOf
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import com.macrofocus.eflux.network.physical.PhysicalNetwork
import com.macrofocus.eflux.network.physical.Zone
import org.molap.network.AbstractNetwork
import org.molap.network.Network

class CrossborderNetwork(physicalNetwork: Network<Bus, Branch>) : AbstractNetwork<Zone, CrossborderBranches>(directed = true) {
    val crossborderNodes = physicalNetwork.nodes
        .groupBy { it.zone }
        .mapValues {
            if(it.key == null) {
                println("Missing zone data for buses: ${it.value.toString()}")
            }
            it.key
        }
        .filter { it.key != null }

    val crossborderLinks = physicalNetwork.links
        .onEach { if(logicalBusIdOf(it.from.id) == logicalBusIdOf(it.to.id)) { println("Not logical $it")} }
        .filter { it.from.zone != null && it.to.zone != null }
        //        .filter { it.from.zone != it.to.zone }
        .groupBy { zonalBranchIdOf(it.from.zone, it.to.zone) }
        .mapValues {
            if(it.value.size == 0) {
                println("No record found for " + it.key)
            }
            Pair(CrossborderBranches(it.key.from,it.key.to, it.value), CrossborderBranches(it.key.to,it.key.from, it.value))
        }
    init {
        crossborderNodes.forEach { addNode(it.value!!) }
        crossborderLinks.forEach {
            addDirectedEdge(crossborderNodes[it.key.from]!!, crossborderNodes[it.key.to]!!, it.value.first)
            addDirectedEdge(crossborderNodes[it.key.to]!!, crossborderNodes[it.key.from]!!, it.value.second)
        }
    }

    override fun getFrom(link: CrossborderBranches): Zone = crossborderNodes[link.from]!!

    override fun getTo(link: CrossborderBranches): Zone = crossborderNodes[link.to]!!
}

class ZonalBranchId(val from: Zone?, val to: Zone?) {
    val name = from?.name + "-" + to?.name

    fun isSameDirection(other: ZonalBranchId): Boolean {
        return from == other.from && to == other.to
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is ZonalBranchId) return false

        if(from == other.from && to == other.to) return true
        if(from == other.to && to == other.from) return true

        return false
    }

    override fun hashCode(): Int {
        var result = from.hashCode() + to.hashCode()
        result = 31 * result
        return result
    }

    override fun toString(): String = name
}

inline fun zonalBranchIdOf(from: Zone?, to: Zone?) : ZonalBranchId = ZonalBranchId(from, to)

private val crossborderCache by lazy { mutableMapOf<PhysicalNetwork, CrossborderNetwork>() }
val PhysicalNetwork.crossborder: CrossborderNetwork
    get() = crossborderCache.getOrPut(this) { CrossborderNetwork(this) }
